import { gql } from "@apollo/client";

export const holdKavaDecision = gql`
  mutation HoldKavaDecision($input: HoldKavaDecision!) {
    holdKavaDecision(input: $input)
  }
`;

export const sendMessageOnOffer = gql`
  mutation SendMessageOnOffer(
    $offer_id: ID!
    $reinsurer_id: ID!
    $reinsurer_representative_id: ID!
    $message: String!
  ) {
    sendMessageOnOffer(input: {
      offer_id: $offer_id
      reinsurer_id: $reinsurer_id
      reinsurer_representative_id: $reinsurer_representative_id
      message: $message
    })
  }
`;
